import { Button, styled } from '@mui/material';

export const ProfileButton = styled(Button)`
  padding: 0;
  border-radius: 100%;
  border: 2px solid var(--dk-bg, white);
  &:hover {
    border-color: black;
    background-color: rgba(255, 255, 255, 0.2);
  }
  > img {
    border-radius: 100%;
    object-fit: cover;
  }
`;
